import React from 'react';
import { initials } from '../../lib/constants';
import { getAvatarUrl } from '../../lib/api';

export default function Avatar({ user, size = 28 }) {
  return (
    <div className="tm-avatar" title={user?.full_name || user?.email} style={{
      width: size, height: size, fontSize: size / 2.5,
      background: user?.avatar_url ? `url(${getAvatarUrl(user.avatar_url)}) center/cover` : (user?.avatar_color || 'var(--trello-text-muted)'),
    }}>{!user?.avatar_url && initials(user)}</div>
  );
}
